export enum Permission {
  MassopsView = 'massops.view',
  MassopsApprove = 'massops.approve',
  MassopsOperateAppeaseUser = 'massops.operate_appease_user',
  MassopsOperateAppeaseUserVaryingPolicy = 'massops.operate_appease_user_varying_policy',
  MassopsOperateAppeaseUserByOrderDelivery = 'massops.operate_appease_user_by_order_delivery',
  MassopsOperateAppeaseUserVaryingAmountByOrderDelivery = 'massops.operate_appease_user_varying_amount_by_order_delivery',
  MassopsOperateAppeaseUserVaryingPolicyByOrderDelivery = 'massops.operate_appease_user_varying_policy_by_order_delivery',
  MassopsOperateCancelOrder = 'massops.operate_cancel_order',
  MassopsOperateContactUser = 'massops.operate_contact_user',
  MassopsOperateGrantCreditBack = 'massops.operate_grant_credit_back',
  MassopsOperateRefundChargeLog = 'massops.operate_refund_charge_log',
  MassopsOperateRefundCustomerFee = 'massops.operate_refund_customer_fee',
  MassopsOperateRefundOrder = 'massops.operate_refund_order',
  MassopsOperateRescheduleDelivery = 'massops.operate_reschedule_delivery',
  MassopsOperateRevokeAppeasement = 'massops.operate_revoke_appeasement',
  MassopsOperateMigrateToppsWallet = 'massops.operate_migrate_topps_wallet',
  MassopsOperateSweepToppsWallet = 'massops.operate_sweep_topps_wallet',
}
